import React from 'react';
import ErrorMessage from './ErrorMessage';
import OfficeService from '../Services/OfficeService';

class OfficeMultiSelect extends React.Component {
  static defaultProps = {
    numberOfCols: 3,
    onChange: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      officeList: [],
      selectedOfficeIds: props.selectedOfficeIds,
    };
  }

  componentDidMount() {
    this.getOffices();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedOfficeIds !== this.props.selectedOfficeIds) {
      this.setState({ selectedOfficeIds: this.props.selectedOfficeIds });
    }
  }

  getOffices() {
    OfficeService.GetOfficesForSelect()
      .then((result) => this.setState({ officeList: result }))
      .catch(() => ErrorMessage.SetErrorMessage('OMS40'));
  }

  renderOffice(office) {
    let cn = 'col-' + 12 / this.props.numberOfCols;
    return (
      <div
        className={cn}
        key={'office' + office.officeId}
      >
        <input
          type='checkbox'
          checked={this.state.selectedOfficeIds.includes(office.officeId)}
          onChange={() => {
            let tempIds = [...this.state.selectedOfficeIds];
            if (tempIds.includes(office.officeId)) {
              const index = tempIds.indexOf(office.officeId);
              if (index > -1) {
                tempIds.splice(index, 1);
              }
            } else {
              tempIds = [...tempIds, office.officeId];
            }
            this.setState({ selectedOfficeIds: tempIds });
            if (this.props.onChange !== null) {
              this.props.onChange(tempIds);
            }
          }}
        />{' '}
        {office.name}
      </div>
    );
  }

  render() {
    return (
      <div className='rounded border'>
        <div className='container m-1'>
          <div className='row'>{this.state.officeList.map((office) => this.renderOffice(office))}</div>
        </div>
      </div>
    );
  }
}

export default OfficeMultiSelect;
